// Modal to add a layer to the currently open publication map.

import { Text } from "@chakra-ui/react";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { AddIcon, RanaButton, RanaModal } from "@nens/ranalib";

import { getOpenMap } from "../../store/selectors";
import { usePublicationStore } from "../../store/store";
import { PublicationFilesTable } from "../map-layer-list";

import { SelectedFileOrLayer } from "./types/file-layer-selection";

interface AddPublicationLayerModalProps {
  isOpen?: boolean;
  onClose: () => void;
}

export const AddPublicationLayerModal = ({
  isOpen = true,
  onClose,
}: AddPublicationLayerModalProps) => {
  const intl = useIntl();
  const addLayer = usePublicationStore((state) => state.addLayerToCurrentMap);
  const [selectedItems, setSelectedItems] = useState<SelectedFileOrLayer[]>([]);
  const { name: currentMapName } = usePublicationStore(getOpenMap);

  const handleAddLayers = () => {
    selectedItems.forEach((item) => addLayer(item.file, item.name, item.layerInFile));
    onClose();
  };

  return (
    <RanaModal
      isOpen={isOpen}
      topBar={intl.formatMessage({
        id: "publication.map.layermodal.title",
        defaultMessage: "Add Publication Layer",
      })}
      onClose={onClose}
      buttons={[
        <RanaButton variant="tertiary" key="cancel" onClick={onClose}>
          <FormattedMessage id="cancel" defaultMessage="Cancel" />
        </RanaButton>,
        <RanaButton
          variant="primary"
          key="add"
          leftIcon={<AddIcon />}
          onClick={handleAddLayers}
          isDisabled={selectedItems.length === 0}
        >
          <FormattedMessage id="publication.map.add_layers" defaultMessage="Add Layers" />
        </RanaButton>,
      ]}
    >
      <>
        <Text mb={4}>
          <FormattedMessage
            id="publication.map.layermodal.instructions"
            defaultMessage="Select the layers you want to add to <mapName>unknown map</mapName>"
            values={{ mapName: (chunks) => <strong>{currentMapName || chunks}</strong> }}
          />
        </Text>
        <PublicationFilesTable selectedItems={selectedItems} onSelectionChange={setSelectedItems} />
      </>
    </RanaModal>
  );
};
